<template>
  <div class="text-gray-900">
    <div
      tabindex="0"
      class="grid cursor-pointer auto-cols-min grid-flow-col items-center gap-2 whitespace-nowrap text-base font-bold leading-5"
      @click="toggle"
      @keydown.enter.space="toggle"
    >
      <slot name="header">
        <span v-tooltip="tooltip" v-text="label" />
      </slot>
      <AppSvgSymbol :name="iconName" :size="icon.size" />
    </div>
    <div v-if="isChecked">
      <slot />
    </div>
  </div>
</template>

<script>
import AppSvgSymbol from '../AppSvgSymbol'
export default {
  name: 'AppToggle',
  components: {
    AppSvgSymbol,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: Object,
      default: () => ({
        open: '@escavador/chevron-up',
        closed: '@escavador/chevron-down',
        size: 12,
      }),
    },
    checked: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: [Object, String],
      default: '',
    },
  },
  data() {
    return {
      isChecked: this.checked,
    }
  },
  computed: {
    iconName() {
      return this.isChecked ? this.icon.open : this.icon.closed
    },
  },
  methods: {
    toggle() {
      this.isChecked = !this.isChecked

      this.$emit('change', {
        label: this.label,
        checked: this.isChecked,
      })
    },
  },
}
</script>
